export const homeTranslationNl = {
    more: "Meer over deze applicatie kan gevonden worden op: ",
    rightClick: "Gebruik de rechter muistknop in tabellen voor meer opties!",
};
